import script from "./VouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./VouchersPage.vue?vue&type=style&index=0&id=d53d9526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53d9526"]])

export default __exports__